const {
  callAuthorizedGraphQLEndpoint,
} = require('../../../../../Module/graphQL')

const getInternalCodesInfo = queryVars => {
  const query = `query (
    $campaignId:ID!
  ) {
    campaignInternalCodes(campaignId: $campaignId) {
      campaignId
      internalCodes{
        id
        internalCode
        internalLink
        city{
          id
          name
        }
      }
    }
  }`

  return callAuthorizedGraphQLEndpoint(query, queryVars)
}

export { getInternalCodesInfo }
